import { settings } from "../../framework/core/settings";

export function getBrandName() {
    if (settings.brandName) {
        return;
    }

    // code for backward compatibility
    settings.appSettings = settings.appSettings || {
        keywords: []
    };

    var brands = Object.keys(window.z.configuration.brandSettings);
    for (var i = 0; i < brands.length; i++) {
        var brand = brands[i];
        var keywords = window.z.configuration.brandSettings[brand].keywords;
        if (keywords) {
            var obj = {};
            obj[brand] = keywords;
            settings.appSettings.keywords.push(obj);
        }
    }
    var url = window.location.href;

    settings.brandName = "servicepro";

    for (var ii = 0; ii < settings.appSettings.keywords.length; ii++) {
        var keywordList = settings.appSettings.keywords[ii];

        var brandKeywordName = Object.keys(keywordList)[0];

        for (var iii = 0; iii < keywordList[brandKeywordName].length; iii++) {
            var brandKeyword = keywordList[brandKeywordName][iii];
            if (url.indexOf(brandKeyword) != -1) {
                settings.brandName = brandKeywordName;
                return false;
            }
        }

        if (settings.brandName != "servicepro") {
            return false;
        }
    }
}
